import PurpleShine from "./PurpleShine";

const CustomBg = () => {
  return (
    <>
      <PurpleShine type="left" />
      <PurpleShine type="right" />
      <PurpleShine type="top" />
      <PurpleShine type="center" />
      <img src="/rings.svg" className="bg-rings-l" />
      <img src="/rings-r.svg" className="bg-rings-r" />
    </>
  );
};

export default CustomBg;
